import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import FAQAccordion from '@Components/Info/FAQAccordion'

const FAQView = (props) => {

    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <h1 className='pagename border-bottom'>{props.H1Header}</h1>
                <FAQAccordion {...props} />
            </div>
        </div>
    );
};

export default FAQView;